import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=48ec621e&scoped=true"
import script from "./Cart.vue?vue&type=script&lang=js"
export * from "./Cart.vue?vue&type=script&lang=js"
import style0 from "./Cart.vue?vue&type=style&index=0&id=48ec621e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ec621e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48ec621e')) {
      api.createRecord('48ec621e', component.options)
    } else {
      api.reload('48ec621e', component.options)
    }
    module.hot.accept("./Cart.vue?vue&type=template&id=48ec621e&scoped=true", function () {
      api.rerender('48ec621e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/Cart.vue"
export default component.exports